export const AUTH_METHOD_PHONE = 1
export const AUTH_METHOD_EMAIL = 2
